import { render, staticRenderFns } from "./VueClock.vue?vue&type=template&id=d669bd5c&"
import script from "./VueClock.vue?vue&type=script&lang=js&"
export * from "./VueClock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports